/** @format */

import { useRouteMatch, Route } from 'react-router-dom';
import List from './List';
import Show from './Show';
import Print from './Print';

const Index = () => {
	let { path, url } = useRouteMatch();

	return (
		<>
			<Route exact path={`${path}`} component={List} />
			<Route exact path={`${path}/:id`} component={Show} />
			<Route exact path={`${path}/show/print`} component={Print} />
		</>
	);
};

export default Index;
